// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "sale_payment".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
import { salePaymentMethodValues, salePaymentStatusValues } from '@borradh-workspace/labels';
/** Response atom for the "sale_payment" table (1:1 with a DB row, on the wire). */
export const salePaymentAtomSchema = z.object({
    id: z.string(),
    saleId: z.string(),
    method: z.enum(salePaymentMethodValues),
    amountCents: z.number(),
    status: z.enum(salePaymentStatusValues),
    stripePaymentIntentId: z.string().nullable(),
    stripePaymentLinkId: z.string().nullable(),
    idempotencyKey: z.string().nullable(),
    refundedCents: z.number(),
    giftCardId: z.string().nullable(),
    readerType: z.string().nullable(),
    appointmentDepositId: z.string().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=salePayment.js.map